var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcNetwork16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  y: 9,
  fill: "#fff",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 6,
  x: 6,
  y: 7,
  fill: "#fff",
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 10,
  x: 12,
  y: 3,
  fill: "#fff",
  rx: 1
})));
export default SvgIcNetwork16;